(function () {
    'use strict';

    angular
        .module('app')
        .directive('eventsList', eventsList);

    eventsList.$inject = ['$window', 'eventSearchService'];

    function eventsList($window, eventSearchService) {
        var directive = {
            bindToController: true,
            controller: ['$scope', '$location', controller],
            controllerAs: '$eventsList',
            restrict: 'EA',
            link: link
        };

        return directive;

        function link($scope) {
			$("#searchBox").autocomplete({
				highlight: true,
                source: function (request, response) {
                    $.ajax({
                        url: "/api/emr/eventSearch/autocomplete",
                        dataType: "json",
                        type: 'Get',
                        data: {
                            term: request.term,
                            size: window.searchAutocompSize
                        },
                        success: function (data) {
                            response($.map(data.Data,
                                function (item) {
                                    return {
                                        label: item,
                                        value: item
                                    };
                                }));
                        }
                    });
				},
				select: function (event, ui) {
	                $(this).val(ui.item.value);
	                $(this).trigger('input'); // Use for Chrome/Firefox/Edge
	                $(this).trigger('change');
	                $(this).closest('form').submit();
                },
                minLength: 2
            });
        }

        function controller($scope, $location) {
            var $ctrl = this;

            $ctrl.text = "";
            $ctrl.sites = [];
            $ctrl.categoryFilters = [];
            $ctrl.selectedCategories = [];
            $ctrl.selectedSites = [];
            $ctrl.selectedTypes = [];
            $ctrl.page = 1;
            $ctrl.pageSize = 10;
            $ctrl.maxPages = 5;
            $ctrl.pages = [];
            $ctrl.results = [];
            $ctrl.shownResults = [];
            $ctrl.totalResults = "";
            $ctrl.sitesHits = 0;
            $ctrl.sort = "asc";
            $ctrl.loadingImage = $('.loading-overlay');
            $ctrl.timer = null;

            var metaSite = $("meta[name=siteName]").attr("content");

            if (metaSite) {
                $ctrl.selectedSites.push(metaSite);
            }

            $ctrl.filterWindow = $('.filter-modal');
            $ctrl.modal = $('.wrap-modal');

            var searchParams = $location.search();

            $ctrl.search = function (e, pageSize, maxPages) {
                if (e) {
                    e.preventDefault();

                    $ctrl.categoryFilters = [];
                }

                $('#searchResults').hide();
                $('.filter-container').hide();
                $ctrl.loadingImage.show();

                $(".ui-menu-item").hide();

                $ctrl.page = 1;
                $ctrl.results = [];
                $ctrl.pageSize = pageSize;
                $ctrl.maxPages = maxPages;

                eventSearchService.getResults($ctrl.text, $ctrl.selectedSites, $ctrl.selectedCategories, $ctrl.selectedTypes)
                    .then(function (results) {
                            if ($ctrl.sort === "desc") {
                                results.Events.sort(byDateDesc);
                            } else {
                                results.Events.sort(byDateAsc);
                            }

                            results.Events.forEach(function (result) {
                                $ctrl.results.push(result);
                            });

                            $ctrl.shownResults = $ctrl.results.slice(0, pageSize);

                            $ctrl.sites.forEach(function (filter) {
                                filter.Count = 0;
                            });

                            results.Sites.forEach(function (filter) {
                                var index = $ctrl.sites.findIndex(function (e) {
                                    return e.Name === filter.Name;
                                });

                                if (index === -1) {
                                    $ctrl.sites.push(filter);
                                } else {
                                    $ctrl.sites.splice(index, 1, filter);
                                }
                            });

                            $ctrl.sitesHits = $ctrl.sum($ctrl.sites, 'Count');

                            //only push filters if this is a new search term
                            if (!$ctrl.categoryFilters.length) {

                                results.Filters.Containers.forEach(function (container) {
                                    $ctrl.categoryFilters.push(container);
                                });
                            }
                            else // update existing counts
                            {
                                $ctrl.categoryFilters = results.Filters.Containers;
                            }

                            var resultsCount = results.Events.length;
                            $ctrl.totalResults = resultsCount + " Results";

                            var pageCount = 1;

                            if (resultsCount > pageSize) {
                                pageCount = Math.ceil(resultsCount / pageSize);
                            }
                            var pages = [];

                            for (var index = 1; index <= pageCount; index++) {
                                pages.push(index);
                            }

                            $ctrl.pages = pages;
                        },
                        function () {
                            console.log('an error occured getting results');
                    });

                $ctrl.loadingImage.hide();
                $('#searchResults').show();
                $('.filter-container').show();
            }

            if (searchParams.categories) {
                var categories = searchParams.categories.split(",");
                $ctrl.selectedCategories = categories.map(function (e) { return parseInt(e, 10) });
            }

            if (searchParams.types) {
                $ctrl.selectedTypes = searchParams.types.split(",");
            }

            $ctrl.clearText = function () {
                $ctrl.text = "";
            }

            $ctrl.sortByDate = function () {
                var skip = ($ctrl.page - 1) * $ctrl.pageSize;

                if ($ctrl.sort === "desc") {
                    $ctrl.sort = "asc";

                    $ctrl.results.sort(byDateAsc);
                } else {
                    $ctrl.sort = "desc";

                    $ctrl.results.sort(byDateDesc);
                }

                $ctrl.shownResults = $ctrl.results.slice(skip, skip + $ctrl.pageSize);
            }

            $ctrl.toggleFilter = function (id, collection, pageSize, maxPages) {
                var index = collection.indexOf(id);

                if (index > -1) {
                    collection.splice(index, 1);
                } else {
                    collection.push(id);
                }

                $ctrl.search(null, pageSize, maxPages);
            }

            $ctrl.expandModal = function () {
                $ctrl.filterWindow.addClass('open-filter');
                $ctrl.modal.removeClass('filter-hide').addClass('filter-show');
            }

            $ctrl.closeModal = function () {
                $ctrl.filterWindow.removeClass('open-filter');
                $ctrl.modal.addClass('filter-hide').removeClass('filter-show');
            }

            function byDateDesc(a, b) {
                if (a.StartDate > b.StartDate) {
                    return -1;
                }
                if (a.StartDate < b.StartDate) {
                    return 1;
                }
                return 0;
            }

            function byDateAsc(a, b) {
                if (a.StartDate < b.StartDate) {
                    return -1;
                }
                if (a.StartDate > b.StartDate) {
                    return 1;
                }
                return 0;
            }

            $ctrl.sum = function (collection, prop) {
                return collection.reduce(function (a, b) {
                    return a + b[prop];
                }, 0);
            }
        }
    }

})();


//////////////////
// WEBPACK FOOTER
// ./static/common/js/directives/_eventsList.js
// module id = 19
// module chunks = 0